<ng-template #initial>
    <div class="email-detail">
        <span>
            HomeDashboard sends monthly update emails to your clients about their properties. <b>We require your approval to send these monthly updates to your clients from your email address</b>.
        </span>
        <div class="Vert-30"></div>
        <span>
            After clicking continue, you will receive an email from SendGrid asking to confirm that they have permission to verify you as a single sender.
        </span>
    </div>
    <div class="Vert-50"></div>
    <div class="row">
        <div class="col-12 email-detail">
            <mat-checkbox [(ngModel)]="isTermsChecked"></mat-checkbox> &nbsp; &nbsp;
            By checking the box, I confirm that HomeDashboard can send emails on my behalf to my clients and I acknowledge that my email campaign will go live.
        </div>
    </div>
</ng-template>
<ng-template #confirmation>
    <div class="email-detail">
        Check your inbox for an email from SendGrid (support@sendgrid.com). Your verification link will be valid for 48 hours. After that, you will need to resend the email, and you can do that by clicking on “set up and launch emails” again in your onboarding checklist.
        <div class="Vert-30"></div>
        Please reach out to Realfinity Support if you do not receive an email: <b>support@realfinity.io</b>
    </div>
</ng-template>
<ng-template #resend>
    <div class="email-detail">
        <ol>
            <li>
                Haven’t gotten the email yet? Click resend below to trigger the email from SendGrid.
            </li>
            <li>
                Already confirmed the email that you received?  <a (click)="onCheckEmailStatus()">Click here to verify you’ve confirmed.</a>
            </li>
            <li>
                If you did not receive an email from SendGrid and you’re still having issues, please reach out to us at <b>support@realfinity.io</b>.
            </li>
        </ol>
    </div>
    <div class="Vert-50"></div>
    <div class="row">
        <div class="col-12 email-detail">
            <mat-checkbox [(ngModel)]="isTermsChecked"></mat-checkbox> &nbsp; &nbsp;
            By checking the box, I confirm that HomeDashboard can send emails on my behalf to my clients and I acknowledge that my email campaign will go live.
        </div>
    </div>
</ng-template>

<div mat-dialog-content class="email-campaign">
    <div class="email-title">Set Up and Launch Emails</div>
    <div class="Vert-30"></div>
    <div *ngIf="dialogMode==='initial'">
        <ng-container *ngTemplateOutlet="initial"></ng-container>
    </div>
    <div *ngIf="dialogMode==='confirmation'">
        <ng-container *ngTemplateOutlet="confirmation"></ng-container>
    </div>
    <div *ngIf="dialogMode==='resend'">
        <ng-container *ngTemplateOutlet="resend"></ng-container>
    </div>
</div>
<mat-dialog-actions class="dialog-actions" align="end">
    <button mat-stroked-button class="btn btn-secondary" (click)="onCancel()">
        {{dialogMode==='confirmation' ? 'Close' : 'Cancel'}}
    </button>
    <button *ngIf="dialogMode!=='confirmation'" mat-stroked-button class="btn btn-primary" (click)="onContinue()"
        [disabled]="!isTermsChecked" cdkFocusInitial>
        {{dialogMode==='initial' ? 'Continue' : 'Resend Email'}}
    </button>
</mat-dialog-actions>
